/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { useBoundArg } from 'solis/navigation';

import SegmentedControl from 'solis/react/primitive/segmented.control';


export default ({ scope, name, initial, ...props }) =>
{
  const [ value, setValue ] = useBoundArg(name, initial, scope);

  return <SegmentedControl {...props} value = {value} onChange = {setValue} />;
};
